// Soft UI Dashboard PRO React icons
import Shop from "examples/Icons/Shop";
import Document from "examples/Icons/Document";
import SpaceShip from "examples/Icons/SpaceShip";
import CustomerSupport from "examples/Icons/CustomerSupport";

// Custom Views
import Register from "views/auth/Register";
import Login from "views/auth/Login";
import ForgotPassword from "views/auth/ForgotPassword";
import VerifyEmail from "views/auth/VerifyEmail";
import VerifyPhone from "views/auth/VerifyPhone";
import ResetPassword from "views/auth/ResetPassword";
import Dashboard from "views/admin/Dashboard";
import CreateCompany from "views/admin/companies/CreateCompany";
import CompaniesList from "views/admin/companies/CompaniesList";
import CompaniesModify from "views/admin/companies/CompaniesModify";
import InvoicesList from "views/admin/invoices/InvoicesList";
import OpenTables from "views/admin/restaurant/OpenTables";
import InvoiceView from "views/admin/invoices/InvoiceView";
import UsersList from "views/admin/users/UsersList";

import Constants from "utils/Constants";
import UsersModify from "views/admin/users/UsersModify";
import UsersCreate from "views/admin/users/UsersCreate";
import UsersEdit from "views/admin/users/UsersEdit";
import RootPage from "views/root/index";
import ContactUs from "views/root/contactus";
import VerifyInvoice from "views/auth/VerifyInvoice";
import InvoiceFailure from "views/auth/InvoiceFailure";
import InvoicesSubmit from "views/admin/invoices/InvoicesSubmit";
import ApiService from "services/ApiService";
import { DataObject, Insights, Restaurant } from "@mui/icons-material";
import TablesHistory from "views/admin/restaurant/TablesHistory";

const routes = [
  {
    type: "collapse",
    name: "ΑΡΧΙΚΗ",
    key: "root",
    route: "/",
    component: <RootPage />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
    showInOutMenu: true,
  },
  {
    type: "collapse",
    name: "ΕΛΕΓΧΟΣ ΠΑΡΑΣΤΑΤΙΚΟΥ",
    key: "verify-invoice",
    route: "/verify-invoice",
    component: <VerifyInvoice />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
    showInOutMenu: true,
  },
  {
    type: "collapse",
    name: "ΑΠΩΛΕΙΕΣ ΔΙΑΣΥΝΔΕΣΗΣ",
    key: "invoice-failure",
    route: "/invoice-failure",
    component: <InvoiceFailure />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
    showInOutMenu: true,
  },
  {
    type: "collapse",
    name: "ΕΠΙΚΟΙΝΩΝΙΑ",
    key: "contact-us",
    route: "/contact-us",
    component: <ContactUs />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
    showInOutMenu: true,
  },

  {
    type: "collapse",
    name: "Register",
    key: "register",
    route: "/register",
    component: <Register />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "Email Verification",
    key: "verify-email",
    route: "/verify-email/:token",
    component: <VerifyEmail />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "View Invoice",
    key: "view-invoice",
    route: "/view-invoice/:uid",
    component: <InvoiceView />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "Phone Verification",
    key: "verify-phone",
    route: "/verify-phone/:token",
    component: <VerifyPhone />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "Login",
    key: "login",
    route: "/login",
    component: <Login />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "Forgot Password",
    key: "forgot-password",
    route: "/forgot-password",
    component: <ForgotPassword />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "Reset Passoword",
    key: "reset-password",
    route: "/reset-password/:token",
    component: <ResetPassword />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },

  {
    type: "collapse",
    name: "Προφίλ",
    key: "users-edit",
    route: "/users-edit/:id",
    component: <UsersEdit accessLevel={Constants.ACCESS_LEVELS.MASTER} />,
    accessLevel: [0],
    noCollapse: true,
    showInSidebar: false,
  },
  {
    type: "collapse",
    name: "Στατιστικά",
    key: "dashboard",
    route: "/dashboard",
    component: <Dashboard accessLevel={Constants.ACCESS_LEVELS.USER} />,
    accessLevel: [
      Constants.ACCESS_LEVELS.USER,
      Constants.ACCESS_LEVELS.AADE,
      Constants.ACCESS_LEVELS.MASTER,
    ],
    icon: <Insights size="12px" />,
    noCollapse: true,
    showInSidebar: true,
  },
  {
    type: "collapse",
    name: "Επεξεργασία Εταιρείας",
    key: "companies-modify",
    route: "/companies/companies-modify/:id",
    showInSidebar: false,
    noCollapse: true,
    accessLevel: [Constants.ACCESS_LEVELS.USER, Constants.ACCESS_LEVELS.MASTER],
    component: <CompaniesModify accessLevel={Constants.ACCESS_LEVELS.USER} />,
  },
  {
    type: "collapse",
    name: "Παραστατικά",
    key: "invoices",
    icon: <Document size="12px" />,
    showInSidebar: true,
    accessLevel: [
      Constants.ACCESS_LEVELS.USER,
      Constants.ACCESS_LEVELS.AADE,
      Constants.ACCESS_LEVELS.MASTER,
    ],
    collapse: [
      {
        name: "Λίστα Παραστατικών",
        key: "invoices-list",
        route: "/invoices/invoices-list",
        accessLevel: [
          Constants.ACCESS_LEVELS.USER,
          Constants.ACCESS_LEVELS.AADE,
          Constants.ACCESS_LEVELS.MASTER,
        ],
        component: <InvoicesList accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
      {
        name: "Χειροκίνητη Καταχώρηση",
        key: "invoices-submit",
        route: "/invoices/invoices-submit",
        accessLevel: [Constants.ACCESS_LEVELS.USER],
        component: <InvoicesSubmit accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Εστίαση",
    key: "tables",
    icon: <Restaurant size="12px" />,
    showInSidebar: true,
    accessLevel: [
      Constants.ACCESS_LEVELS.USER,
      Constants.ACCESS_LEVELS.AADE,
      Constants.ACCESS_LEVELS.MASTER,
    ],
    collapse: [
      {
        name: "Ανοιχτά τραπέζια",
        key: "open-tables",
        route: "/restaurant/open-tables",
        accessLevel: [
          Constants.ACCESS_LEVELS.USER,
          Constants.ACCESS_LEVELS.AADE,
          Constants.ACCESS_LEVELS.MASTER,
        ],
        component: <OpenTables accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
      {
        name: "Ιστορικό τραπεζιών",
        key: "tables-history",
        route: "/restaurant/tables-history",
        accessLevel: [
          Constants.ACCESS_LEVELS.USER,
          Constants.ACCESS_LEVELS.AADE,
          Constants.ACCESS_LEVELS.MASTER,
        ],
        component: <TablesHistory accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Εταιρείες",
    key: "companies",
    icon: <Shop size="12px" />,
    showInSidebar: true,
    accessLevel: [Constants.ACCESS_LEVELS.USER, Constants.ACCESS_LEVELS.MASTER],
    collapse: [
      {
        name: "Δημιουργία Εταιρείας",
        key: "companies-create",
        route: "/companies/companies-create",
        showInSidebar: true,
        accessLevel: [Constants.ACCESS_LEVELS.USER],
        component: <CreateCompany accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
      {
        name: "Λίστα Εταιρειών",
        key: "companies-list",
        route: "/companies/companies-list",
        showInSidebar: true,
        accessLevel: [Constants.ACCESS_LEVELS.USER, Constants.ACCESS_LEVELS.MASTER],
        component: <CompaniesList accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Χρήστες",
    key: "users",
    icon: <CustomerSupport size="12px" />,
    showInSidebar: true,
    accessLevel: [
      Constants.ACCESS_LEVELS.USER,
      Constants.ACCESS_LEVELS.AADE,
      Constants.ACCESS_LEVELS.MASTER,
    ],
    collapse: [
      {
        name: "Δημιουργία Χρήστη",
        key: "users-create",
        route: `/users/users-create`,
        accessLevel: [Constants.ACCESS_LEVELS.MASTER],
        component: <UsersCreate accessLevel={Constants.ACCESS_LEVELS.MASTER} />,
      },
      {
        name: "Λίστα Χρηστών",
        key: "users-list",
        route: "/users/users-list",
        accessLevel: [Constants.ACCESS_LEVELS.MASTER],
        component: <UsersList accessLevel={Constants.ACCESS_LEVELS.MASTER} />,
      },
      {
        name: "Προφίλ",
        key: "users-update",
        route: `/users/users-update`,
        accessLevel: [
          Constants.ACCESS_LEVELS.USER,
          Constants.ACCESS_LEVELS.AADE,
          Constants.ACCESS_LEVELS.MASTER,
        ],
        component: <UsersModify accessLevel={Constants.ACCESS_LEVELS.USER} />,
      },
    ],
  },
  {
    type: "collapse",
    name: "API Docs",
    key: "api-docs",
    href: `${ApiService.baseUrl}/swagger-ui/index.html#`,
    icon: <DataObject size="12px" />,
    showInSidebar: true,
    noCollapse: true,
    accessLevel: [
      Constants.ACCESS_LEVELS.USER,
      Constants.ACCESS_LEVELS.AADE,
      Constants.ACCESS_LEVELS.MASTER,
    ],
    showInOutMenu: true,
  },
];

export default routes;
